// extracted by mini-css-extract-plugin
module.exports = {"container":"i_I9","button":"i_JA","light":"i_JB","dark":"i_JC"};